import React, { useState } from "react";
import FilterBar from "../UI/FilterBar";
import { CustomButton } from "../UI/CustomButtons";

function Actions({ onDownloadExcel, onFilterChange, filter }) {
  const handleFilterChange = (newFilters) => {
    onFilterChange(newFilters);
  };

  return (
    <div className="d-flex align-items-center justify-content-between">
      <FilterBar onFilterChange={handleFilterChange} filter={filter} />
      <CustomButton text="Export All" onClick={onDownloadExcel} padding="4px 12px" />
    </div>
  );
}

export default Actions;
